import classNames from 'classnames';
import * as React from 'react';

// A type alias would defeat react/prop-types resolution, so an empty interface it is
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface FieldLabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {}

export const FieldLabel: React.FunctionComponent<FieldLabelProps> = ({className, children, ...rest}: FieldLabelProps) => (
    <label className={classNames('mp-field-label', className)} {...rest}>
        {children}
    </label>
);
